import script from "./detaiWangLuoKeCheng.vue?vue&type=script&setup=true&lang=js"
export * from "./detaiWangLuoKeCheng.vue?vue&type=script&setup=true&lang=js"

import "./detaiWangLuoKeCheng.vue?vue&type=style&index=0&id=00f0f16d&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00f0f16d"]])

export default __exports__